import './RatioJumpHint.css';

const PROPORTIONS_ANCHOR_ID = 'proportions-anchor';

/**
 * Mobile-only hint button rendered directly below the ingredient picker.
 * Tapping it scrolls to the proportions panel (which on mobile sits further
 * down the page since we re-ordered the layout). Hidden on desktop where
 * the proportion inputs are visible in the sidebar.
 *
 * The link target is set up by the host element wrapping
 * `<SelectedIngredients>` — that element must have `id={PROPORTIONS_ANCHOR_ID}`.
 */
function RatioJumpHint({ count }) {
  if (!count || count < 1) return null;
  const label =
    count === 1
      ? 'Set the proportion below'
      : `Set proportions for your ${count} ingredients below`;

  return (
    <a className="ratio-jump-hint" href={`#${PROPORTIONS_ANCHOR_ID}`}>
      <span aria-hidden="true" className="ratio-jump-hint__arrow">↓</span>
      <span>{label}</span>
    </a>
  );
}

export { PROPORTIONS_ANCHOR_ID };
export default RatioJumpHint;
